import React, { useState } from "react";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import useAppSelector from "~/hooks/use-app-selector.ts";
import {
	guestLogin,
	syncGetStartedPreferences,
} from "~/features/user/store-slice.ts";
import { selectUser } from "~/features/user/selectors.ts";
import GetStartedFlow from "./get-started-flow.tsx";

function GetStartedPage({ onComplete }: { onComplete: () => void }) {
	const dispatch = useAppDispatch();
	const user = useAppSelector(selectUser);
	const [getStartedComplete, setGetStartedComplete] = useState(false);

	const handleComplete = () => {
		setGetStartedComplete(true);
		if (user.type === "signedIn") {
			dispatch(syncGetStartedPreferences());
		}
		onComplete();
	};

	const onGuestLogin = () => {
		dispatch(guestLogin());
	};

	// Show get started flow for everyone, but pass a prop to skip name/email for signed in users
	const isLoggedIn = user.type === "signedIn";

	if (getStartedComplete) {
		return null;
	}

	return (
		<main
			className="app-main"
			style={{ backgroundColor: "#ffffff", position: "relative" }}
		>
			<div className="container-fluid">
				<GetStartedFlow
					onGuestLogin={onGuestLogin}
					skipNameAndEmail={isLoggedIn}
					onComplete={handleComplete}
				/>
			</div>
		</main>
	);
}

export default GetStartedPage;
